module.exports = __webpack_public_path__ + "00_cheeks.b95dd33a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer3/00_cheeks.png
// module id = /XQH
// module chunks = 0